import { PropTypes } from 'prop-types'

import { HStack, Text, Image } from '@chakra-ui/react'

import { buildAssetUrlString } from '@!/Util'

import StoreCoinSvg from '@images/store_coin.svg'

export const CoinOwned = ({ coinCount }) => {
  return (
    <HStack spacing={0}>
      <Image htmlWidth={14} htmlHeight={14} src={buildAssetUrlString(StoreCoinSvg)} />
      <Text fontSize="2xs" as="span" fontWeight="semibold" ml={1}>
        {coinCount.toLocaleString()}
      </Text>
    </HStack>
  )
}

CoinOwned.propType = {
  coinCount: PropTypes.number.isRequired,
}
